module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_aqua@2x-5a4decdd803472fde058136258998ba7.webp";